/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xheW91dHMvbWFpbi1sYXlvdXQvY29tcG9uZW50cy9jbG9zZS1ldmVudHMvY2xvc2UtZXZlbnRzLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
